import React from 'react'
import ContentLoader from 'react-content-loader'
import { Card } from '@atd/rui-base.mui.card'
import { CARD_SX } from '../ravenV5Theme'

const GrowerCardLoader = (props) => (
    <Card className="gffCard" sx={CARD_SX}>
        <ContentLoader
            speed={2}
            width={'100%'}
            height={113.6}
            backgroundColor="#f3f3f3"
            foregroundColor="#ecebeb"
            {...props}
        >
            <rect x="16" y="20" rx="3" ry="3" width="45%" height="15" />
            <rect x="16" y="44" rx="3" ry="3" width="30%" height="15" />
            <rect x="16" y="86" rx="3" ry="3" width="50%" height="15" />
        </ContentLoader>
    </Card>
)

export default GrowerCardLoader
